import { z } from 'zod';
import { ActorTypeSchema } from './actor.schema';

/** Who soft-deleted a record, as an operator surface shows it. `name` is null for SYSTEM and for an id that no longer resolves. */
export const DeletedBySchema = z.object({
  type: ActorTypeSchema,
  id: z.uuid(),
  name: z.string().nullable(),
});

export type DeletedBy = z.infer<typeof DeletedBySchema>;
